import { render, staticRenderFns } from "./CostBearerDrivingLessonDetails.vue?vue&type=template&id=f1bf43b4&"
import script from "./CostBearerDrivingLessonDetails.vue?vue&type=script&lang=ts&"
export * from "./CostBearerDrivingLessonDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports